import {
  EntityType,
  humanizeEntityType,
} from '../../../constants/user-info/ENTITY_TYPES';

export const getHumanizeEntityType = (entityType: EntityType): string => {
  return humanizeEntityType[entityType] ?? entityType;
};
